import { render, staticRenderFns } from "./ParentNewsLetter.vue?vue&type=template&id=4bb5db5f&"
import script from "./ParentNewsLetter.vue?vue&type=script&lang=js&"
export * from "./ParentNewsLetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports